import styles from "./Select.module.css";
import { ChevronDown } from "lucide-react";
import type { selectProps } from "./types.props";

const Select = ({
    label,
    error,
    required,
    className = "",
    wrapperClassName = "",
    variant = "default",
    id,
    name,
    children,
    ...rest
}: selectProps) => {
    const selectId = id || `select-${name}`;

    const containerClasses = [
        styles["select-container"],
        styles[`select--${variant}`],
        wrapperClassName,
    ]
        .filter(Boolean)
        .join(" ");

    const selectClasses = [
        styles["select-element"],
        error ? styles.error : "",
        className,
    ]
        .filter(Boolean)
        .join(" ");

    return (
        <div className={containerClasses}>
            {label && (
                <label htmlFor={selectId} className={styles["select-label"]}>
                    {label}{" "}
                    {required && <span className={styles["select-required"]}>*</span>}
                </label>
            )}

            <div className={styles["select-wrapper"]}>
                <select
                    id={selectId}
                    name={name}
                    className={selectClasses}
                    required={required}
                    aria-invalid={!!error}
                    aria-describedby={error ? `${selectId}-error` : undefined}
                    {...rest}
                >
                    {children}
                </select>

                <ChevronDown
                    className={styles["select-dropdown-icon"]}
                    aria-hidden="true"
                />
            </div>

            {error && (
                <p id={`${selectId}-error`} className={styles["select-error-message"]}>
                    {error}
                </p>
            )}
        </div>
    );
};

export default Select;
